var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripadvisor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "tripadvisor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b7a388",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 13,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 13,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 13,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 13,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 13,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38 7.5a15.52 15.52 0 0 1 15.24 0M5.5 7.5h-5a5.64 5.64 0 0 1 1.09 2.22M18.5 7.5h5a5.64 5.64 0 0 0-1.09 2.22M10.54 16.1 12 18.5l1.46-2.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripadvisor);
export default __webpack_public_path__ + "static/media/tripadvisor.89abdd5b4977dadfc3b725a9bd7d52fc.svg";
export { ForwardRef as ReactComponent };